import type { ReactElement } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Ctext } from '../Ctext';
import { CTEXTINPUT_DEFAULT_FONT_SIZE_PX, CTEXTINPUT_DROPDOWN_LINE_HEIGHT, CtextinputDataName, } from './Ctextinput.constants';
interface CtextinputDropdownValueProps {
    displayValue: string;
    dropdownTextOpacity: number;
    textOpacity: number;
}
export function CtextinputDropdownValue({ displayValue, dropdownTextOpacity, textOpacity, }: CtextinputDropdownValueProps): ReactElement {
    return (
	<Ctext size={CTEXTINPUT_DEFAULT_FONT_SIZE_PX} weight={FontWeight.Light} color={ColorType.White} opacity={textOpacity} style={{ lineHeight: CTEXTINPUT_DROPDOWN_LINE_HEIGHT }}>
      <span style={{ opacity: dropdownTextOpacity }}>
        {displayValue}
      </span>
    </Ctext>
    );
}
